import React from "react";
import DataReader from "./components/DataReadingComponents/DataReader";
function App() {
    return (
        <div>
            <DataReader />
        </div>
    );
}

export default App;
